module.exports = __webpack_public_path__ + "static/media/editor-project-view.54e8adbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/editor-project-view.jpg
// module id = 1003
// module chunks = 4